<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      :style="{
        'width': $q.screen.gt.xs ? '500px' : '100%',
        'max-width': '500px'
      }"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section v-if="formField">
          <div class="column">
            <div class="row q-ma-sm items-center q-gutter-sm">
              <div class="col text-h6">
                {{ formTitle }}
              </div>
              <q-btn
                class="col-auto"
                icon="close"
                flat
                round
                dense
                @click="close"
              />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <!-- NOTE: We must pass :model="sectionClone" to all of these for the reasons explained
            in the code comments for `initializeSectionClone()` -->
              <model-form-input
                :model="sectionClone"
                :field="`config.formFields[${index}].label`"
                value-type="String"
                :reverse="false"
                class="col-6"
                label="Label"
                :rules="[val => !!val || 'Field is required']"
              />
              <model-form-select
                :model="sectionClone"
                :field="`config.formFields[${index}].type`"
                value-type="String"
                class="col-6"
                label="Type"
                :options="fieldTypeOptions"
                :rules="[val => !!val || 'Field is required']"
                map-options
                emit-value
              />
            </div>
            <div
              v-if="formField.type === GENERIC_FORM_FIELD_TYPES.SELECT || formField.type === GENERIC_FORM_FIELD_TYPES.CHECKBOX"
              class="row q-col-gutter-sm"
            >
              <model-form-select
                v-if="(GENERIC_FORM_FIELD_TYPES.CHECKBOX && formField.multiple) || formField.type === GENERIC_FORM_FIELD_TYPES.SELECT"
                :model="sectionClone"
                :field="`config.formFields[${index}].options`"
                value-type="[String]"
                multiple
                use-input
                use-chips
                new-value-mode="add-unique"
                class="col-6"
                label="Options"
                @keyup.enter.stop
              />
              <model-form-checkbox
                :model="sectionClone"
                :field="`config.formFields[${index}].multiple`"
                value-type="Boolean"
                class="col-6"
                label="Allow Multiple"
                size="lg"
              />
            </div>
            <div class="row q-col-gutter-sm">
              <model-form-checkbox
                v-if="formField.type !== GENERIC_FORM_FIELD_TYPES.HEADING && formField.type !== GENERIC_FORM_FIELD_TYPES.CHECKBOX"
                :model="sectionClone"
                :field="`config.formFields[${index}].required`"
                value-type="Boolean"
                class="col-6"
                label="Required"
                size="lg"
              />
              <model-form-checkbox
                :model="sectionClone"
                :field="`config.formFields[${index}].fullWidth`"
                value-type="Boolean"
                class="col-6"
                label="Full Width"
                bottom-slots
                size="lg"
              />
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            :label="formSaveLabel"
            color="primary"
            @click="save()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { createGenericFormField, GENERIC_FORM_FIELD_TYPES } from 'src/models/generic-form/GenericFormField'
import SectionConfigArrayElementFormMixin from 'src/modules/admin/components/ModelForm/mixins/SectionConfigArrayElementFormMixin'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'GenericFormFieldForm',
  mixins: [SectionConfigArrayElementFormMixin, FormValidationMixin],
  configuration: ['currentCircuit', 'currentSite'],
  emits: ['save'],
  computed: {
    // Required by mixin
    field () {
      return 'formFields'
    },
    // required by mixin
    typeName () {
      return 'Form Field'
    },
    formField () {
      return this.currentArrayElement
    }
  },
  created () {
    _.extend(this, {
      GENERIC_FORM_FIELD_TYPES,
      fieldTypeOptions: this.$mh.asOptions(_.values(GENERIC_FORM_FIELD_TYPES))
    })
  },
  methods: {
    // required by mixin
    getElementDefaultProps () {
      return createGenericFormField()
    },
    save () {
      this.validateForm(() => {
        this.$emit('save', _.clone(this.formField))
        this.close()
      })
    }
  }
}

</script>
